import { useNavigate } from 'react-router-dom'
import './NotFound.css'

export function NotFound() {
  const navigate = useNavigate()

  return (
    <div className="not-found">
      <div className="not-found-icon">404</div>
      <h1>Página no encontrada</h1>
      <p>Lo sentimos, la página que buscas no existe.</p>
      <button onClick={() => navigate('/')} className="home-button">
        Volver al inicio
      </button>
    </div>
  )
}
